import React, { forwardRef } from 'react';
import cn from 'classnames';
import {
  Mark,
  MarkContainer,
  RadioContainer,
  RadioInput,
  RadioLabel,
  RadioLabelText,
  RadioText,
  AlertText
} from './styled';
import { NewRadioButtonProps } from './types';

export const NewRadioButton = forwardRef<HTMLDivElement, NewRadioButtonProps>(
  (
    {
      data,
      name,
      color,
      stat,
      cypress,
      currentValue,
      onChangeHandler,
      containerClassNames,
      additionalClasses,
      markerPosition = 'right',
      isSelected,
      label,
      additionalControlElement,
      icon,
      secondLineElement,
      disabled = false
    },
    ref
  ) => {
    const classes = cn(containerClassNames, additionalClasses);
    const isChecked = isSelected || currentValue === data.id;

    return (
      <RadioContainer
        ref={ref}
        className={classes}
        data-cy="radio-container"
        data-stat={stat}
        markerPosition={markerPosition}
        $isChecked={isChecked}
        $isDisabled={disabled}
      >
        <RadioInput
          type="radio"
          name={name}
          value={data.id}
          onChange={onChangeHandler}
          data-cy={`${cypress}-${data.id}`}
          checked={isChecked}
          disabled={disabled}
        />
        {additionalControlElement}
        {label && (
          <RadioLabel data-cy="search-radio__label">
            <RadioLabelText tag="caption_2">{label}</RadioLabelText>
          </RadioLabel>
        )}
        {icon}
        <RadioText
          tag="body_2"
          $color={color}
          $isChecked={isChecked}
          data-cy={cypress}
          $isTwoLines={!!secondLineElement}
          $isDisabled={disabled}
        >
          {data.name}
          {!!secondLineElement && <AlertText>{secondLineElement}</AlertText>}
        </RadioText>

        <MarkContainer $isChecked={isChecked}>
          <Mark />
        </MarkContainer>
      </RadioContainer>
    );
  }
);

NewRadioButton.displayName = 'NewRadioButton';
